'use client';

import React__default, { useContext, useState, useEffect, useMemo } from 'react';
import { RightColumnContentWrapper, NotSelectedParent, ChildrensWrapper, ParentTitle, ChildrensContent } from './RightColumnContent.css.js';
import { CascaderContext } from '../../../../context/reducer.js';
import BriefcaseIcon from '../../../../images/BriefcaseIcon/index.js';
import DropdownItem from '../DropdownItem/index.js';
import { getChildrenListByParentId } from '../../../../../TreeSelect/helpers.js';
import { ELanguage } from '../../../../../Utils/constants.js';
import { getParentCheckState, getChildrenCheckState } from '../../../../helper.js';

var RightColumnContent = function () {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, t = _a.t;
    var parentId = state.parentId, keyword = state.keyword, hoverParentId = state.hoverParentId, isHover = state.isHover, temporaryValue = state.temporaryValue;
    var langCode = props.langCode, options = props.options, isMobile = props.isMobile, selectOptions = props.selectOptions;
    var parent = options.parent, children = options.children;
    var _b = useState(-1), selectedParentId = _b[0], setSelectedParentId = _b[1];
    useEffect(function () {
        if (isMobile && parentId === -1) {
            return;
        }
        var newParentId = parentId;
        if (isHover) {
            newParentId = hoverParentId;
        }
        setSelectedParentId(newParentId);
    }, [isMobile, parentId, hoverParentId]);
    var renderChildren = function () {
        if (!isMobile && selectedParentId === -1 && keyword.length > 0) {
            return React__default.createElement(React__default.Fragment, null);
        }
        if (!isMobile && selectedParentId === -1) {
            return (React__default.createElement(NotSelectedParent, null,
                React__default.createElement(BriefcaseIcon, null),
                React__default.createElement("p", null, t('Select job function.'))));
        }
        // Find children by parentId
        var childrens = getChildrenListByParentId(selectedParentId.toString(), children);
        if (!selectOptions.isSingleSelect) {
            childrens.unshift({
                id: -1,
                name: 'Tất cả',
                nameEn: 'All'
            });
        }
        // Get Parent info
        var parentFiltered = parent.filter(function (item) { return item.id === selectedParentId; });
        var parentItemName = '';
        if (parentFiltered.length > 0) {
            parentItemName = parentFiltered[0].name;
        }
        return (React__default.createElement(ChildrensWrapper, null,
            !isMobile && React__default.createElement(ParentTitle, null, parentItemName),
            React__default.createElement(ChildrensContent, null, childrens.map(function (item, index) {
                var _a;
                // detect have children or not
                var parentCheckState = getParentCheckState(selectedParentId, temporaryValue);
                var itemCheckState = 'none';
                if (parentCheckState === 'checked') {
                    itemCheckState = 'checked';
                }
                else if (parentCheckState === 'half') {
                    // Get item check state
                    itemCheckState = getChildrenCheckState(selectedParentId, item.id, temporaryValue);
                }
                // Special case is '-1' (All) option
                if (item.id === -1) {
                    itemCheckState = parentCheckState;
                }
                return (React__default.createElement(DropdownItem, { key: "children-".concat(parentId, "-").concat(item.id, "-").concat(index), checkState: itemCheckState, isSelected: false, isSelectedValue: itemCheckState !== 'none', label: langCode === ELanguage.VI ? item.name : item.nameEn, id: item.id, parentId: selectedParentId, isHaveChildren: false, jobCount: (_a = item.jobs) !== null && _a !== void 0 ? _a : 0 }));
            }))));
    };
    return useMemo(function () { return (React__default.createElement(RightColumnContentWrapper, { "data-cname": 'dropdown__body__rightColumn', isMobile: isMobile }, renderChildren())); }, [keyword, selectedParentId, parent, children, isMobile, temporaryValue]);
};

export { RightColumnContent as default };
//# sourceMappingURL=index.js.map
